/**
 * @file calculators.js
 *
 */

(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.calculatorTabs = {
    attach: function (context, settings) {
      var calcLabel = $(
        ".calculator-band__calculator > div > div > h2",
        context
      );

      $(".calculator__tabs-container").insertAfter(
        ".calculator-band__subheading"
      );

      $(".calculator .tab_content", context).hide();
      $(".calculator .tab_content:first", context).show();

      $(".calculator__tab", context).on("click", function () {
        var getCopy = $(this).text();
        //console.log(getCopy);
        calcLabel.text(getCopy);
        $(".calculator .tab_content", context).hide();
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).show();

        $(".calculator__tab", context).removeClass("active");
        $(this).addClass("active");
      });
    },
  };

  Drupal.behaviors.rangeSlider = {
    attach: function (context, settings) {
      const _maximumSignificantDigits = 6; // i.e. 100000 = 6 significant digits
      const _maxTextInputLength = 8; // i.e. $100,000 = 8 characters

      $('.calculator input[type="range"]', context).rangeslider({
        polyfill: false,
        onInit: function () {
          const amount = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumSignificantDigits: _maximumSignificantDigits,
          }).format(this.$element.val());
          this.output = $(
            `<input type="text" inputmode="numeric" class="range-output" aria-label="Value Range" maxlength="${_maxTextInputLength}" />`
          )
            .insertBefore(this.$range)
            .val(amount);
        },
        onSlide: function (position, value) {
          const amount = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumSignificantDigits: _maximumSignificantDigits,
          }).format(value);
          this.output.val(amount);
        },
      });

      $('.calculator input[type="text"]', context).on("input", function () {
        // Strip all non-numeric characters
        let inputValue = parseInt(this.value.replace(/[^0-9]/g, ""));

        // Zero out if input value is empty
        if (!inputValue) inputValue = 0;

        // Update the respective range slider
        $(this)
          .prev('.calculator input[type="range"]')
          .val(inputValue)
          .change();
      });
    },
  };

  $(function () {
    $(".currency-mask").mask("000,000,000", { reverse: true });
    $(".currency-mask").wrap("<div class='form-group'></div>");
    $(".currency-mask").on("input", function () {
      $(this).val()
        ? $(this).closest(".form-group").addClass("has-value")
        : $(this).closest(".form-group").removeClass("has-value");
    });

    $(".rate-mask").mask("00.0%", { reverse: true });
  });
})(jQuery, Drupal);
